import { connect } from 'formik'
import { flatten } from 'lodash'
import { useCallback, useRef, useState } from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'

import { MentionsRichTextEditorWithFormik } from '@/components/Form/MentionsRichTextEditor/MentionsRichTextEditor'
import {
  SecondaryRoundedButton,
  StyledWandIcon,
  VariableInputContainer
} from '@/pages/SpaceAppBuilder/components/StyledComponents'
import VariableOverlay from '@/pages/SpaceAppBuilder/components/VariableInput/VariableOverlay'
import operationsMessages from '@/pages/SpaceAppBuilder/FeaturesPage/Operations/messages'
import { FieldTypes, Variable } from '@/pages/SpaceAppBuilder/utilities/interfaces'
import { getAllFlattenedVariables } from '@/pages/SpaceAppBuilder/utilities/variableHelpers'

import messages from './messages'
import { AnyContentBlockTypes } from './NotificationDetail'

const StyledBlockMentionsRichTextEditorWithFormik = styled(MentionsRichTextEditorWithFormik)`
  .public-DraftEditor-content {
    min-height: 200px;
  }
`

const initialData = {
  color: 'dark',
  horizontalAlignment: 'left',
  size: 'default',
  id: 'tblock',
  isSubtle: false,
  spacing: 'large',
  text: '',
  type: 'TextBlock',
  weight: 'default',
  wrap: true
}

interface TextBlockProps {
  name: string
  id: string | number
  data: any
  onChange: () => {}
  variables: Variable[][]
  readOnly?: boolean
}

const Component = connect(({ name, variables, readOnly = false }: TextBlockProps) => {
  const intl = useIntl()

  const flattenedVariables = flatten(variables)
  const addVariableRef = useRef<any>(() => {})
  const [showDetailVariablePopOver, setShowDetailVariablePopOver] = useState<any>(false)
  // @ts-expect-error
  const addMention = useCallback(addMentionFn => (addVariableRef.current[name] = addMentionFn), [name])

  return (
    <VariableInputContainer>
      <StyledBlockMentionsRichTextEditorWithFormik
        readOnly={readOnly}
        setAddMention={addMention}
        name={`${name}.text`}
        mentions={getAllFlattenedVariables(flattenedVariables)}
        placeholder={intl.formatMessage(messages.notificationContentPlaceholder)}
        label={intl.formatMessage(messages.notificationDetailContent)}
        hasStaticToolBar
      />
      {flattenedVariables.length > 0 && !readOnly && (
        <>
          {showDetailVariablePopOver && (
            <VariableOverlay
              onSelectVariable={(variable: Variable) => addVariableRef.current[name](variable)}
              onClose={() => {
                setShowDetailVariablePopOver(false)
              }}
              variables={variables}
              validVariableTypes={[
                FieldTypes.STRING,
                FieldTypes.BOOLEAN,
                FieldTypes.INTEGER,
                FieldTypes.NUMBER,
                FieldTypes.ANY
              ]}
            />
          )}
          <SecondaryRoundedButton
            onClick={() => {
              setShowDetailVariablePopOver(true)
            }}
          >
            <>
              <StyledWandIcon />
              <span>{intl.formatMessage(operationsMessages.addVariableButton)}</span>
            </>
          </SecondaryRoundedButton>
        </>
      )}
    </VariableInputContainer>
  )
})

const TextBlock: AnyContentBlockTypes = { Component }

TextBlock.displayName = 'TextBlock'

TextBlock.initialData = { ...initialData }

export default TextBlock
